<template>
  <viewer-form :can-back="true" @back="doBack">
    <form-caption :text="title" />
    <dating :value="publication_from" />
    <notification-body-browse-item :value="escape_body" />
    <div v-for="(attachment,index) in attachments" :key="index">
      <div class="main">
        <p>{{attachment.file_name}} </p>
        <div class="child">
          <download-button @click="doDownload(attachment.id)" />
        </div>
      </div>
    </div>
  </viewer-form>
</template>

<script>
import {mapState} from 'vuex';
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import ViewerForm from '@/views/templates/forms/ViewerForm'
import FormCaption from '@/views/atoms/FormCaption'
import Dating from '@/views/atoms/Dating'
import DownloadButton from '@/views/molecules/buttons/DownloadButton'
import NotificationBodyBrowseItem from '@/views/molecules/browseItems/NotificationBodyBrowseItem';

export default {
  name: "NotificationViewer",
  components: {
    ViewerForm,
    FormCaption,
    Dating,
    DownloadButton,
    NotificationBodyBrowseItem
  },
  mixins: [AddonLoadPageEvent],
  computed: {
    ...mapState('notification_form', {
      title: state => state.data.title,
      publication_from: state => state.data.publication_from,
      escape_body: state => state.data.escape_body,
      attachments: state => state.data.attachments,
    }),
  },
  methods: {
    loadPage() {
      return this.$store.dispatch('notification_form/load', {id: this.$route.params.id}).catch(() => this.$root.failApi());
    },
    doDownload(id) {
      return this.$store.dispatch('notification_form/download', { id }).catch(() => this.$root.failApi());
    },
    doBack() {
      this.$router.push({name: 'Top'});
    },
  }
}
</script>
<style scoped>
.main{
  display: flex;
  width: 30rem;
}
.child{
  margin-left: auto;
}
</style>